export const blue = "#3079d2";
export const red = "#e65d60";
export const green = "#56d36c";
const white = "#ffffff";

export const prizeDraws = [
    {
      balls: [
        { show: true, color: blue, number: null },
        { show: true, color: blue, number: null },
        { show: true, color: red, number: null },
        { show: true, color: red, number: null },
        { show: true, color: green, number: null },
      ],
      groupBreaks: [1, 3],
      prize: "$300,000 + ACUMULADO",
    },
    {
      balls: [
        { show: true, color: blue, number: null },
        { show: true, color: blue, number: null },
        { show: true, color: red, number: null },
        { show: true, color: red, number: null },
        { show: false, color: white, number: null },
      ],
      groupBreaks: [1],
      prize: "$300,000",
    },
    {
      balls: [
        { show: true, color: blue, number: null },
        { show: true, color: blue, number: null },
        { show: true, color: red, number: null },
        { show: false, color: blue, number: null },
        { show: false, color: blue, number: null },
      ],
      groupBreaks: [1],
      prize: "$100",
    },
    {
      balls: [
        { show: true, color: blue, number: null },
        { show: true, color: blue, number: null, separatorAfter: "ó"},
        { show: false, color: white, number: null },
        { show: true, color: red, number: null },
        { show: true, color: red, number: null },
      ],
      groupBreaks: [],
      prize: "O INVERSO $300,000",
    },
    {
      balls: [
        { show: true, color: blue, number: null },
        { show: true, color: red, number: null },
        { show: false, color: green, number: null },
        { show: false, color: red, number: null },
        { show: false, color: green, number: null },
      ],
      groupBreaks: [0],
      prize: "Ticket Gratis",
    },
    {
      balls: [
        { show: true, color: green, number: null },
        { show: false, color: white, number: null },
        { show: false, color: white, number: null },
        { show: false, color: white, number: null },
        { show: false, color: white, number: null },
      ],
      groupBreaks: [],
      prize: "Ticket Gratis",
    },
  ];